import { ActivitiesSection, DashboardAdmin, DashboardStaff } from '@dashboard'
import { isOwnerOrAdministrator, selectCurrentUserRole, useAppSelector } from 'mmfintech-backend-api'
import { tr } from 'mmfintech-commons'
import './Dashboard.scss'

function Dashboard() {
  const customerRole = useAppSelector(selectCurrentUserRole)

  return (
    <div className='dashboard-wrapper'>
      <div className='dashboard-left'>
        <div className='dashboard-title title'>{tr('PORTAL.DASHBOARD.TITLE', 'Overview')}</div>
        {isOwnerOrAdministrator(customerRole) ? <DashboardAdmin /> : <DashboardStaff />}
      </div>

      <div className='dashboard-right'>
        <div className='dashboard-right-title'>{tr('PORTAL.DASHBOARD.ACTIVITIES', 'Activity')}</div>
        <ActivitiesSection />
      </div>
    </div>
  )
}

export default Dashboard
